module.exports = __webpack_public_path__ + "static/scale-model-of-voyage-to-soulsville-in-austin-texas-939fdf5524d77b41ff50fb28fc31a7dc.png";